export const appEnvironment = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL?.trim() ?? "",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? "",
  demoMode: import.meta.env.VITE_DEMO_MODE === "true",
  googleMapsBrowserKey: import.meta.env.VITE_GOOGLE_MAPS_BROWSER_KEY?.trim() ?? "",
  googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID?.trim() ?? "",
};

export const hasSupabaseConfiguration =
  appEnvironment.supabaseUrl.length > 0 && appEnvironment.supabaseAnonKey.length > 0;
